import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

import { debounce } from 'lodash';

@Component
export class PredictiveSearch extends ThemeComponent {
    @Ref() searchInput!: HTMLInputElement;
    @Ref() searchResults!: HTMLDivElement;
    @Ref closeSearchButton!: HTMLButtonElement;

    scrollListener: (() => void)|null = null;

    init() {
        this.searchInput.addEventListener('input',
            debounce(() => {
                this.onChange();
            }, 300)
        );

        this.closeSearchButton.classList.add('hidden');
    }

    onChange() {
        const searchTerm: string = this.searchInput.value.trim();

        if(!searchTerm.length) {
            this.closeSearchButton.classList.add('hidden');
            this.clearResults();
            this.closeResults();
            return;
        }

        this.getResults(searchTerm);
    }

    appendResults(text: string): void {
        const format: Document = new DOMParser().parseFromString(text, 'text/html');
        const resultsMarkup: string | undefined =
            format.querySelector('#shopify-section-predictive-search')?.innerHTML || undefined;

        if(resultsMarkup === undefined) {
            return;
        }

        this.searchResults.innerHTML = resultsMarkup;
    }

    clearResults(): void {
        const results: HTMLDivElement | null = document.querySelector('#predictive-search-results') || null;

        if(results) {
            results.remove();
        }
    }

    openResults(): void {
        this.setAttribute('open', 'true');
        document.body.classList.add('search-open');
        this.toggleScrollEvent(); // add scroll event

        // Set max height for mobile search
        const announcementBar: HTMLElement | null = document.querySelector('announcement-bar');
        const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
        const header: HTMLElement | null = document.querySelector('.site-header__row');
        const headerHeight = header ? header.offsetHeight : 0;
        const totalHeight = announcementBarHeight + headerHeight;
        const searchDiv: HTMLElement | null = document.querySelector('.predictive-search--mobile');
        const maxHeight = `calc(100vh - ${totalHeight}px)`;
        if(searchDiv) {
            searchDiv.style.maxHeight = maxHeight;
        }

        this.closeSearchButton.classList.remove('hidden');

        this.$listen(this.closeSearchButton, 'click', () => {
            this.scrollOccured();
            document.body.classList.remove('search-open');
            this.closeSearchButton.classList.add('hidden');
        });

        this.closeOnOutsideClick();

    }

    closeResults(): void {
        this.setAttribute('open', 'false');
        this.toggleScrollEvent(); // remove scroll event
    }

    scrollOccured() {
        this.searchInput.value = "";
        this.clearResults();
        this.closeResults();
    }

    getResults(searchTerm: string): void {
        const url: string =
            // eslint-disable-next-line max-len
            `/search/suggest?q=${searchTerm}&resources[type]=product,page,article,collection&section_id=predictive-search`;

        fetch(url)
            .then((response) => {
                if(!response.ok) {
                    throw new Error(`${response.status}`);
                }
                return response.text();
            })
            .then((text) => {
                this.appendResults(text);
                this.openResults();
            })
            .catch((error) => {
                throw error;
            });
    }

    toggleScrollEvent() {
        if (!this.scrollListener) {
            this.scrollListener = () => this.scrollOccured();
            window.addEventListener('scroll', this.scrollListener);
        } else {
            window.removeEventListener('scroll', this.scrollListener);
            this.scrollListener = null;
        }
    }

    closeOnOutsideClick() {
        document.addEventListener('click', (event) => {
            const target = event.target as Node;
            if (!this.searchResults.contains(target) && !this.searchInput.contains(target)) {
                this.scrollOccured();
                this.closeSearchButton.classList.add('hidden');
            }
            document.body.classList.remove('search-open');
        });
    }


}
